module.exports = __webpack_public_path__ + "img/12.e9910432.jpg";